import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Loading from "../../../hoc/Loading/Loading";
import axios from "../../../axios";
import * as actionCreators from "../../../modules/actions/index";
import { connect } from "react-redux";
import * as url from "../../../utils/url";
import {
  whiteLabelStyling,
  isUserRemoved,
  groupContentFields,
  groupPrivacyStatusDesc,
} from "../../../utils/constants";
import moment from "moment";
import {
  Table,
  Modal,
  ModalBody,
  Button,
  ListGroupItem,
  Progress,
  DropdownMenu,
  DropdownToggle,
  Dropdown,
  Alert,
  ModalHeader,
} from "reactstrap";
import MemberItem from "../Components/MemberItem";
import noEventUsers from "../../../assets/onboarding/wStory.svg";
import loadingItems from "../../../assets/placeholders/kpi_available.svg";
import OfficeMateProfile from "../../office/OfficeMateProfile/OfficeMateProfile";
import { isMobile } from "../../../utils/deviceInfo";
import OfficeMateProfileMobilePopup from "../../office/OfficeMateProfile/OfficeMateProfileMobilePopup";

class GroupMembers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: "",
      members: this.props.members,
      dropdownOpen: false,
      isSuccess: false,
      removedItem: null,
      isAPI: false,
      profilePopupOpen: false,
      profilePopupData: {
        userId: null,
        orgId: null,
      },
    };
  }

  componentWillReceiveProps(nextProps){
    if(JSON.stringify(this.state.members) !== JSON.stringify(nextProps.members)){
     
      this.setState({members:nextProps.members})
    }
  }

  componentDidMount() {
    this.props.highlightMenu("M");
  }

  componentDidUpdate(prevProps, prevState) {
    let { members } = this.props;
  
    console.log(prevState);
    if (prevProps.members.length != members.length) {
      this.setState({ members });
    }
  }

  removeMember = userId => {
    this.props.removeMember(userId);
  };

  viewMember = user => {
    let link = `/home/${this.props.user.profile.organizationId._id}/profile/${user.o_id}`;
    this.props.history.push(link);
  };

  onDismiss = () => {
    this.setState({ isSuccess: false, removedItem: null });
  };

  handleProfilePopup = user => {
    this.setState({
      profilePopupOpen: true,
      profilePopupData: {
        userId: user.o_id,
        orgId: this.props.user.profile.organizationId._id,
      },
    });
  };

  toggleProfilePopup = () => {
    if (this.state.profilePopupOpen) {
      this.setState({
        profilePopupData: {
          userId: null,
          orgId: null,
        },
      });
    }

    this.setState({ profilePopupOpen: !this.state.profilePopupOpen });
  };
  renderMembers = tasks => {
    const { orgAdmin } = this.props.user.profile;
    let { members, isSuccess, removedItem } = this.state;
    let { group,currentRole } = this.props;

    return (
      <span>
        {isSuccess ? (
          <Alert color="success" isOpen={isSuccess} toggle={this.onDismiss}>
            <strong>{removedItem.name}</strong> was removed.
          </Alert>
        ) : null}

        <ul className="mobile-group-members responsive-table">
          {!isMobile && (
            <li
              className="table-header dashboardHeader member-no-show-mob"
              // style={whiteLabelStyling(['backgroundColor'], this.props.user.profile.organizationId)}
            >
              <div className="col col-6">Profile</div>
              <div className="col col-5">Role</div>
              {/* <div className="col col-4">Date Joined</div> */}
              <div className="col col-1"></div>
            </li>
          )}
         {console.log("currentRole",currentRole)}
          {members.map((item, idx) => {
            return (
              <MemberItem
                removeMember={this.removeMember}
                currentUserRole={currentRole}
                group={group}
                single_member={item}
                key={item.o_id + idx}
                handleProfilePopup={this.handleProfilePopup}
                updateCurrentRole={this.props.updateCurrentRole}
            
              />
            );
          })}
        </ul>
      </span>
    );
  };




  render() {
    let { members, isAPI, isLoaded, profilePopupData, profilePopupOpen } =
      this.state;

    return (
      <span className="grp_single_page_stories_container member_component_container">
        <Modal isOpen={profilePopupOpen} toggle={this.toggleProfilePopup}>
          <ModalHeader toggle={this.toggleProfilePopup}>
            View member
          </ModalHeader>
          <ModalBody>
            <OfficeMateProfileMobilePopup
              officematePopupId={profilePopupData.userId}
              officematePopupOrgId={profilePopupData.orgId}
            />
          </ModalBody>
        </Modal>
        <div className="grp_single_page_resources_component_container">
          {members && members.length > 0 ? (
            this.renderMembers()
          ) : (
            <span className="group_members_page_no_users">
              <div className="event_guest_modal_no_data bgWhite boxShadow1">
                <img
                  src={noEventUsers}
                  className="event_guest_modal_no_data_img"
                />
                <span className="event_guest_modal_no_data_txt">
                  This group currently has no members
                </span>
              </div>
            </span>
          )}
        </div>
      </span>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports: state.reports,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: data =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: data =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: data =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: header => dispatch(actionCreators.navBarUpdate(header)),
    updateReport: dashboard => dispatch(actionCreators.updateReport(dashboard)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(GroupMembers, axios)));
